define('lq/dropDownsListPositioning',[ ], function () {
    'use strict';

    var positionList = function ($list, $dropElement, offsetFromInput, offsetToTheEdge, defMaxHeight) {
        var winHeight = $(window).height();
        var scrollTop = $(window).scrollTop();

        var rect = $dropElement[0].getBoundingClientRect();
        var inputTop = rect.top;
        var inputBottom = rect.bottom;

        var verticalBorderWidthOfList = $list.outerHeight() - $list.innerHeight();
        var targetMaxHeight = defMaxHeight;
        var spaceBelow = winHeight - inputBottom - offsetFromInput - offsetToTheEdge - verticalBorderWidthOfList;
        var spaceAbove = inputTop - offsetFromInput - offsetToTheEdge - verticalBorderWidthOfList;

        var finalHeight = 0;
        var isAbove = false;

        if (spaceBelow >= targetMaxHeight) {
            isAbove = false;
            finalHeight = targetMaxHeight;
        } else if (spaceAbove >= targetMaxHeight) {
            isAbove = true;
            finalHeight = targetMaxHeight;
        } else {
            isAbove = spaceAbove > spaceBelow;
            finalHeight = isAbove ? spaceAbove : spaceBelow;
        }

        var css = {
            maxHeight: finalHeight
        };

        if (isAbove) {
            css.top = (inputTop + scrollTop) - offsetFromInput;
            css.transform = 'translateY(-100%)'; // Pulls the list up by its own height
        } else {
            css.top = (inputBottom + scrollTop) + offsetFromInput;
            css.transform = 'none';
        }

        $list.css(css);
    };

    return {
        positionList: positionList
    };
});

